export default __webpack_public_path__ + "static/media/ssimg1.dd69790c.jpg";